import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uploadVideo, deleteVideo } from '../../../features/playerProfile/playerProfileSlice';
import { VideoPlayerModal } from '../../../components/VideoPlayer/VideoPlayerModal';
import { VideoCarousel } from '../../../components/VideoPlayer/VideoCarousel';
import { CARD, CardTitle, EditButton, SECONDARY_BUTTON } from './profileCard';

export const VideoSection = () => {
  const dispatch = useDispatch();
  const { profile, videoLoading } = useSelector((state) => state.playerProfile);
  const [videos, setVideos] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isPlayerOpen, setIsPlayerOpen] = useState(false);

  useEffect(() => {
    if (profile?.videos) {
      setVideos(profile.videos);
    } else {
      setVideos([]);
    }
  }, [profile?.videos]);

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      dispatch(uploadVideo(file));
    }
  };

  const handleVideoDelete = (videoId) => {
    if (window.confirm('Are you sure you want to delete this video?')) {
      dispatch(deleteVideo(videoId));
    }
  };

  const handleVideoClick = (video) => {
    if (!isEditing) {
      setSelectedVideo(video);
      setIsPlayerOpen(true);
    }
  };

  const handleClosePlayer = () => {
    setIsPlayerOpen(false);
    setSelectedVideo(null);
  };

  return (
    <section className={CARD}>
      <CardTitle title="Video">
        {!isEditing ? (
          <EditButton onClick={() => setIsEditing(true)}>Edit videos</EditButton>
        ) : (
          <button type="button" onClick={() => setIsEditing(false)} className={SECONDARY_BUTTON}>
            Done
          </button>
        )}
      </CardTitle>

      <VideoCarousel
        videos={videos}
        onVideoClick={handleVideoClick}
        onVideoDelete={handleVideoDelete}
        isEditing={isEditing}
        showUploadSlots={true}
        onVideoUpload={handleVideoUpload}
        videoLoading={videoLoading}
        maxVideos={6}
      />

      {/* Video Player Modal */}
      <VideoPlayerModal
        isOpen={isPlayerOpen}
        onClose={handleClosePlayer}
        video={selectedVideo}
        profile={profile}
        allVideos={videos}
      />
    </section>
  );
};

export default VideoSection;
